import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';
import { Tooltip, TooltipOptions } from '@com-delta-omnichannel/mach-core-js';
import { Journey } from './models/journey.interfaces';

@Component({
  selector: 'idp-journey',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './journey.component.html',
  styleUrl: './journey.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class JourneyComponent implements AfterViewInit {
  @Input() content: Journey = {} as Journey;

  BASIC_TOOLTIP_OPTIONS: TooltipOptions = {
    id: 'basic-tooltip',
    positions: 'top',
    positionElement: 'tooltip-trigger-basic',
    triggerEvent: 'toggle'
  };

  private tooltipInstance!: Tooltip;

  ngAfterViewInit() {
    if (this.content.pending) {
      this.tooltipInstance = new Tooltip(this.BASIC_TOOLTIP_OPTIONS);

      document.addEventListener('click', (event: Event) => {
        const target = event.target as HTMLElement;
        if (target.closest('.tooltip-close-btn')) {
          this.tooltipInstance.close();
        }
      });
    }
  }
}
